import React, { ComponentType, createContext } from 'react';

import { Content } from 'api';

export const ContentContext = createContext({});
const { Provider } = ContentContext;

export interface IWithContent {
  content?: Content;
}

const withContent = <T extends {}>(Component: ComponentType<T & IWithContent>) => (props: T) => (
  <ContentContext.Consumer>
    {(providerProps: IWithContent) => <Component {...props} {...providerProps} />}
  </ContentContext.Consumer>
);

export { Provider as ContentProvider, withContent };
